import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mixerLiveStatus: '',
    streamPlayerVisible: false,
    twitchLiveStatus: '',
    streamPlayer: ''
  },
  mutations: {
    changePlayer(state, streamPlayer) {
      state.streamPlayer = streamPlayer;
    },
    setMixerLiveStatus(state, status) {
      state.mixerLiveStatus = status;
    },
    setTwitchLiveStatus(state, status) {
      state.twitchLiveStatus = status;
    },
    toggleStreamPlayer(state) {
      state.streamPlayerVisible = !state.streamPlayerVisible;
    }
  },
  actions: {
    streamPlayer: state => state.streamPlayer,
    streamPlayerVisible: state => state.streamPlayerVisible,
    mixerLiveStatus: state => state.mixerLiveStatus,
    twitchLiveStatus: state => state.twitchLiveStatus
  }
});
